import _ from "lodash";
import React, { useState, useEffect } from "react";

import { Route, Switch, Redirect, useRouteMatch } from "react-router-dom";
import { Error400 } from "views/pages";
import IntlMessages from "util/intlMessages";
import ContentTable from "./Table";
import { PageTitle } from "components/standart";
// import AddContent from "./Add";
import ContentInfo from "./Info";

const DataNodes = (props) => {
  const { url, path } = useRouteMatch();
  const { breadCrumbs } = props;

  const contentInfo = (dataNode) => {
    return `${url}/node_${dataNode._id}`;
  };

  const contentForm = (dataNode) => {
    return `${contentInfo(dataNode)}/form`;
  };

  breadCrumbs.push({
    title: <IntlMessages id="DataNodes" />,
    url,
    actions: [
      // <AddContent {...{ contentForm }} />
    ],
  });

  return (
    <Switch>
      <Route exact path={`${path}`}>
        <PageTitle {...breadCrumbs} />

        <ContentTable {...{ contentInfo, contentForm }} />
      </Route>

      <Route path={`${path}/node_:nodeId`}>
        <ContentInfo {...{ breadCrumbs, contentInfo, contentForm }} />
      </Route>

      <Route component={Error400} />
    </Switch>
  );
};

export default DataNodes;
